// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityRequestSearchBase {
    static getAttributeTypeMap() {
        return MedicalEligibilityRequestSearchBase.attributeTypeMap;
    }
}
MedicalEligibilityRequestSearchBase.discriminator = undefined;
MedicalEligibilityRequestSearchBase.additionalProperties = false;
MedicalEligibilityRequestSearchBase.attributeTypeMap = [
    {
        "name": "request",
        "baseName": "request",
        "type": "MedicalEligibilityRequestBase"
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
];
//# sourceMappingURL=medicalEligibilityRequestSearchBase.js.map